import React from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import firebase from "../../firebase/firebase";
export default function UserDetails(){
  const {uid} = useParams();
  const [user, setUser] = React.useState();
  React.useEffect(() => {
    firebase
      .firestore()
      .collection('users')
      .where('uid', '==', uid)
      .get()
      .then((result) => {
        if (result?.size > 0) {
          setUser(result?.docs[0].data());
        } else {
          setUser()
        }
      })
  }, [])
  const navigator = useNavigate();
  if (user) return(
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5} >
        <Typography variant={'h5'} color={'primary'}>
          User details
        </Typography>



        {
          user?.userType === 'investor' &&
          (
            <>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Full name
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300, textTransform:'capitalize'}} noWrap={true}>
                {user?.name}
              </Typography>
            </Stack>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Email
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                {user?.email}
              </Typography>
            </Stack>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Onboarded as
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                {user?.organizationDetails && user?.organizationDetails?.type}
              </Typography>
            </Stack>
              {user?.organizationDetails && user?.organizationDetails?.type === 'Company' &&
                <>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>

                </>

              }
            </>
          )
        }
        {
          user?.userType === 'creator' &&
          <>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Full name
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300, textTransform:'capitalize'}} noWrap={true}>
                {user?.name}
              </Typography>
            </Stack>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Email
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                {user?.email}
              </Typography>
            </Stack>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Creator role
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                {user?.role}
              </Typography>
            </Stack>
            <Stack direction={'row'} spacing={3}>
              <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                Onboarded as
              </Typography>
              <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                {user?.organizationDetails && user?.organizationDetails?.type}
              </Typography>
            </Stack>
            {user?.organizationDetails && user?.organizationDetails?.type === 'Company' &&
            <>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                  Company name
                </Typography>
                <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                  {user?.organizationDetails?.companyName}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                  Company email
                </Typography>
                <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                  {user?.organizationDetails?.email}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                  Company address
                </Typography>
                <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                  {user?.organizationDetails?.companyAddress}
                </Typography>
              </Stack>
              <Stack direction={'row'} spacing={3}>
                <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                  Company type
                </Typography>

                <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                  {user?.organizationDetails?.companyType}
                </Typography>
              </Stack>

            </>

            }
            {user?.organizationDetails && user?.organizationDetails?.type === 'SPV' &&

              <>
                <Typography variant={'h5'} color={'primary'}>SPV details</Typography>
                <Stack direction={'row'} spacing={3}>
                  <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                    Country
                  </Typography>
                  <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                    {user?.organizationDetails?.spvCountry}
                  </Typography>
                </Stack>
                <Stack direction={'row'} spacing={3}>
                  <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                    SPV name
                  </Typography>
                  <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                    {user?.organizationDetails?.spvName}
                  </Typography>
                </Stack>
                <Typography variant={'subtitle1'} sx={{fontWeight: 'bolder', fontSize:18}}>
                  Members
                </Typography>
                {
                  user?.organizationDetails?.peoples && user?.organizationDetails?.peoples?.length > 0 &&
                  user?.organizationDetails?.peoples?.map((member) => (
                  <>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Name
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {member?.name}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Email
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {member?.email}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Phone number
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {member?.number}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Role
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {member?.role}
                      </Typography>
                    </Stack>
                  </>
                  ))

                }
                <Typography variant={'subtitle1'} sx={{fontWeight: 'bolder', fontSize:18}}>
                  Companies
                </Typography>
                {
                  user?.organizationDetails?.companies && user?.organizationDetails?.companies?.length > 0 &&
                  user?.organizationDetails?.companies?.map((company) => (
                  <>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Name of representative
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.representativeName}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Role of representative
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.representativeRole}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Phone number of the representative
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.representativeNumber}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Company name
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.companyName}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Company email
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.email}
                      </Typography>
                    </Stack>
                    <Stack direction={'row'} spacing={3}>
                      <Typography variant={'body1'} sx={{color: '#444444',width: 200}}>
                        Company address
                      </Typography>
                      <Typography variant={'body1'} sx={{color: '#888',maxWidth: 300,}} noWrap={true}>
                        {company?.address}
                      </Typography>
                    </Stack>
                  </>
                  ))

                }
              </>
            }

              </>

        }

        <Stack direction={"row"}  justifyContent="center"
               alignItems="center">
          <Button onClick={() => navigator(-1)} color={'primary'} variant={'contained'}>Go back</Button>
        </Stack>
      </Stack>
    </Container>
  )
  return (    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}/>)
}